import React from 'react';
import PropTypes from 'prop-types';
import Popover from 'react-bootstrap/lib/Popover';
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';
import i18n from '../../src/i18n/translate';
import ConfirmationModal from './ConfirmationModal';
import Button from './Button';
import Storage from '../util/Storage';

export default class ReportDownload extends React.Component {
  static propTypes = {
    downloadAction: PropTypes.func,
    downloadParams: PropTypes.any,
    downloadUrl: PropTypes.string,
    downloadProcessing: PropTypes.bool,
    closeTimeoutModal: PropTypes.func,
    downloadTimedOut: PropTypes.bool
  }

  componentWillReceiveProps(newProps) {
    if (!this.props.downloadUrl && newProps.downloadUrl) {
      this.handleDownload();
      window.location.href = newProps.downloadUrl;
    }
  }

  handleDownload = () => {
    Storage.setItem("suppressLoadingClass", true);
  }

  render() {
    if (this.props.downloadProcessing) {
      return <span>{i18n.t('Building File...')}</span>;
    } else if (this.props.downloadUrl) {
      return <a download={true} href={this.props.downloadUrl} onClick={this.handleDownload}>{i18n.t('Download')}</a>
    } else if (this.props.downloadTimedOut) {
      return (
        <ConfirmationModal title={i18n.t("Report Sent")} onConfirm={this.props.closeTimeoutModal} canClose={true} show={true} confirmOnly={true}>
          <div>{i18n.t("Seems that it's taking longer than we expected to create your report. Once your report is ready we'll send you an email with a link to download it.")}</div>
        </ConfirmationModal>);
    } else {
      const overlay = <Popover id="email-report">{i18n.t('Click to download report')}</Popover>;
      return (
        <OverlayTrigger placement="top" overlay={overlay}>
          <Button
            label={<span>{i18n.t('Download Results')}</span>}
            icon="download"
            style="link"
            onClick={() => this.props.downloadAction(this.props.downloadParams)} />
        </OverlayTrigger>
      );
    }
  }
}
